'use strict';
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    // WRITE YOUR CODE HERE
    if (Object.keys(data).length === 0) return;
    var list = document.createElement('ul');
    for(var key in data){
        var li = document.createElement('li');
        li.textContent = key;
        list.append(li);
        if (Object.keys(data[key]).length !== 0) createTree(li, data[key]);
    }
    element.append(list);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.d659b77e.js.map
